import Tr from 'translations/Translations';
import { redirect } from 'libs/RouterPath';
import reduxStore from 'redux/store'
import {setStepperState} from "redux/actions";

export const createButton = (trKey, onClick, variant, Icon, color, disabled = false, toLeft = false, translateLabel = true) => ({
	label: translateLabel === true ? Tr(trKey) : trKey,
	onClick,
	variant,
	Icon,
	color,
	disabled,
	toLeft
})

export const createHrefButton = (trKey, href, variant, Icon, color) => (
	createButton(
		trKey,
		() => { redirect(href) },
		variant,
		Icon,
		color
	)
)

export const createSubmitFormButton = (trKey, variant, Icon, color, disabled, isSaveButton) => {
	const { form, stepper } = reduxStore.getState();
	const formId = stepper.state;
	const func = isSaveButton ? form[formId] : ()=>reduxStore.dispatch(setStepperState());

	return createButton(
		trKey,
		() => func ? func() : {},
		variant,
		Icon,
		color,
		disabled || !func
	)
}

export const createSubmitFormButtonEnotice = (trKey, variant, Icon, color, disabled, isSaveButton, setOpenPopup) => {
	const { form, stepper } = reduxStore.getState();
	const formId = stepper.state;
	const func = async () => {
		isSaveButton
			? form[formId]()
			: reduxStore.dispatch(setStepperState());
		setOpenPopup();
	};

	return createButton(
		trKey,
		() => func ? func() : {},
		variant,
		Icon,
		color,
		disabled || !func
	)
}

export default createButton;